import {h} from 'preact';

const SearchResultsPane = ( {children} ) =>
    <div
        data-testid="search-results-pane"
        className="fade-in a-duration-med search-results absolute flex flex-col bg-grey-lightest w-full overflow-hidden overflow-y-auto shadow-md">
        <div
            className="search-results-list overflow-hidden overflow-y-scroll scrolling-touch pb-20 md:pb-0">
            {children}
        </div>
    </div>;

export default SearchResultsPane;
